import {
  API_GET_USER_SESSION,
  API_LOGIN,
  API_LOGOUT,
  API_ME,
  API_VALIDATE_TOKEN,
} from "../../utils/api/ApiConstant";
import { defaultAxios } from "../../utils/api/axios";
import showToast from "../../utils/toastUtil";
import { userAction } from "./user-slice";
import { uiActions } from "../ui/ui-slice";
import {
  hashedPassword,
  mapPermissionByForm,
} from "../../shared/helper/common";
import store, { dispatch } from "../../store";
import { queryClient } from "../../utils/queryClientUtil";
import { IS_PRODUCTION, URL_DEV, URL_PRO } from "../../utils/constance";

let logoutTimer = null;

const startLogoutTimer = (expiresInMs) => {
  if (logoutTimer) {
    clearTimeout(logoutTimer);
  }

  logoutTimer = setTimeout(async () => {
    await logoutUser();
  }, expiresInMs);
};

export const loginUser = async (dispatch, payload, navigate) => {
  try {
    dispatch(uiActions.setLoading(true));
    console.log("🚀 ~ loginUser ~ payload:", payload);
    const { password } = payload;
    const compareString = hashedPassword(password);
    console.log("🚀 ~ loginUser ~ compareString:", compareString);

    const body = {
      ...payload,
      password: password,
    };
    console.log("🚀 ~ loginUser ~ body:", body);
    const response = await defaultAxios.post(API_LOGIN, body);
    console.log("🚀 ~ loginUser ~ response:", response);

    if (response?.success && response?.data?.mfaRequired) {
      console.log("devs 100");

      console.log("otp");

      navigate("/verify-otp", {
        state: {
          data: response?.data,
        },
      });
      return;
    }

    if (response?.success) {
      console.log("devs 200");
      storeCredentials({
        dispatch,
        data: { ...response?.data, compareString },
      });
    }
  } catch (err) {
    console.error("Login failed:", err);
    showToast.error(err?.message || "Failed");
  } finally {
    dispatch(uiActions.setLoading(false));
  }
};

// const postLogout = async () => {
//   await defaultAxios.post(API_LOGOUT);
// };

export const clearStorage = () => {
  // dispatch(userAction.clearUser());

  queryClient.clear();

  dispatch(userAction.clearUserStore());
  dispatch(uiActions.clearAllModals());
};

export const logoutUser = async () => {
  try {
    const token = store.getState()?.user?.token;

    const BASE_URL = IS_PRODUCTION ? `${URL_PRO}/api` : `${URL_DEV}/api`;

    fetch(`${BASE_URL}${API_LOGOUT}`, {
      method: "POST",
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
    });
    if (logoutTimer) {
      clearTimeout(logoutTimer);
    }
    localStorage.removeItem("cipherMark");
    localStorage.removeItem("tokenExpiry");
    clearStorage();
  } catch (error) {
    // showToast.error(error?.data?.message);
  }
};

let isLogoutInProgress = false;

export const handleAxiosError = async (error) => {
  if (isLogoutInProgress) {
    return Promise.reject(error);
  }

  if (error?.message === "Network Error" || error?.response?.status === 401) {
    isLogoutInProgress = true;

    try {
      logoutUser();
      // if (error?.response?.status === 401) {
      //   showToast.warning("Session expired. Please log in again.");
      // }
    } catch (e) {
      console.error("Logout error:", e);
    } finally {
      isLogoutInProgress = false;
    }
  }

  return Promise.reject(error?.response?.data);
};

export const sessionDetails = async (dispatch) => {
  try {
    const data = await defaultAxios.get(API_ME);
    console.log("🚀 ~ sessionDetails ~ data:", data);

    if (data?.success) {
      const formData = mapPermissionByForm(data?.data?.menu);

      dispatch(userAction.setFormWithPermission(formData));
      dispatch(userAction.setFormList(data?.data?.menu));
      dispatch(userAction.updateUser(data?.data?.userProfile));
      dispatch(userAction.setSessionDetails(data?.data?.session));
    }
  } catch (err) {
    console.error("Login failed:", err);
  } finally {
    dispatch(uiActions.setLoading(false));
  }
};

export const checkSessionExpiry = () => {
  const expiry = localStorage.getItem("tokenExpiry");

  if (!expiry) return;

  const remainingTime = Number(expiry) - Date.now();

  if (remainingTime <= 0) {
    logoutUser();
    return;
  }

  dispatch(userAction.setSessionExpiresIn(remainingTime));
  startLogoutTimer(remainingTime);
};

export const validateTokenOnRefresh = async () => {
  const token = store.getState()?.user?.token;

  if (!token) return;

  try {
    const response = await defaultAxios.get(API_VALIDATE_TOKEN);

    if (response && response?.success === false) {
      await logoutUser();
    }
  } catch (err) {
    console.error("Token validation failed:", err);
  }
};

export const verifyOtp = async ({ dispatch, payload, url }) => {
  try {
    dispatch(uiActions.setLoading(true));

    const response = await defaultAxios.post(url, payload);
    console.log("🚀 ~ verifyOtp ~ response:", response);

    if (response?.success) {
      storeCredentials({
        dispatch,
        data: { ...response?.data },
      });
    }
  } catch (err) {
    showToast.error(err.message || "Failed");
    return err;
  } finally {
    dispatch(uiActions.setLoading(false));
  }
};

const storeCredentials = ({ dispatch, data, isVerify = false }) => {
  console.log("🚀 ~ storeCredentials ~ storeCredentials:");
  sessionDetails(dispatch);

  const expiresInMinutes = data?.expiresIn || 0;
  const expiresInMs = expiresInMinutes * 60 * 1000;

  dispatch(userAction.setToken(data?.accessToken));
  dispatch(userAction.setSessionExpiresIn(expiresInMs));

  dispatch(uiActions.setHeading("Dashboard"));

  if (!isVerify) localStorage.setItem("cipherMark", data?.compareString);

  const expiryTime = Date.now() + expiresInMs;
  localStorage.setItem("tokenExpiry", expiryTime);

  startLogoutTimer(expiresInMs);
};
